const state = reactive({
  display: false,
  index: -1,
})

const useZoomGalleryActions = () => {
  const toggle = (display: boolean, index?: number) => {
    state.display = display
    if (typeof index === 'number' && !isNaN(index)) {
      state.index = index
    }
  }

  return {
    state,
    toggle,
  }
}

export default useZoomGalleryActions
